import React, { useState } from "react"

const TimeInput = ({ value, onChange }) => {
  const handleChange = e => {
    const inputValue = e.target.value

    // Allow only numeric digits and ":"
    const sanitizedValue = inputValue.replace(/[^0-9:]/g, "")

    // Ensure the time format is HH:mm (24-hour format)
    if (
      /^([01]?[0-9]|2[0-3]):?[0-5]?[0-9]?$/.test(sanitizedValue) ||
      sanitizedValue === ""
    ) {
      // Automatically add ":" after two digits for hours
      if (/^[0-9]{2}$/.test(sanitizedValue)) {
        onChange(`${sanitizedValue}:`)
      } else {
        onChange(sanitizedValue)
      }
    }
  }

  // useEffect(() => {}, [value])

  return (
    <input
      className="form-control"
      type="text"
      value={value}
      placeholder="__:__"
      maxLength="5"
      onChange={handleChange}
    />
  )
}

export default TimeInput
